export default function getResource(label, vars = []) {
    const resources = {
        title: 'Créer un compte',
        inStoreMemberTitle: 'Vérifier votre adresse courriel',
        backButtonAriaLabel: 'Retour',
        joinBiFreeShip: 'Joignez-vous au programme de fidélisation Beauty Insider. Accumulez des points, profitez de *l’expédition standard GRATUITE*, échangez des récompenses et plus encore.',
        emailAddresLabel: 'Adresse de courriel',
        firstNameLabel: 'Prénom',
        lastNameLabel: 'Nom de famille',
        passwordLabel: `Mot de passe (${vars[0]} à ${vars[1]} caractères)`,
        phoneNumber: 'Numéro de téléphone',
        phoneNumberBenefit: 'Entrez votre numéro de téléphone pour faciliter la recherche en magasin.',
        marketingCheckbox: 'Inscrivez-moi aux alertes marketing par texto de Sephora.',
        zipCodeLabel: 'Code postal (facultatif)',
        staySignedInLabel: 'Garder ma session ouverte',
        and: ' et ',
        biTerms: 'MODALITÉS BEAUTY INSIDER',
        privacyPolicy: 'politique de confidentialité',
        receiveOffers: ', et vous acceptez de recevoir automatiquement les offres Beauty Insider par courriel.',
        noticeFinancialIncentive: 'Avis de prime financière',
        byClicking: 'En cliquant sur « S’inscrire », vous reconnaissez être résident du Canada ou des États-Unis et (1) avoir lu',
        disclosure: 'Divulgation des alertes par texto Sephora :',
        byEntering: ' En entrant votre numéro de téléphone, vérifiez les',
        signMeUp: ' Inscrivez-moi aux alertes marketing par texto Sephora,',
        clicking: ' En cliquant sur le bouton ‘’ S’inscrire ’’ et en confirmant votre inscription, vous consentez à recevoir des messages publicitaires automatiques récurrents, y compris des rappels de panier abandonné, et confirmez que vous avez lu et accepté les',
        textTerm: 'MODALITÉS DES TEXTOS',
        agreeTo: ' acceptez ',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        message: ' La fréquence des messages varie. Le consentement n’est pas une condition d’achat. Des frais de messagerie texte et de données peuvent s’appliquer. Consultez notre ',
        privacy: 'POLITIQUE DE CONFIDENTIALITÉ',
        noticeOf: 'AVIS DE PRIME FINANCIÈRE',
        textStop: ' Textez ARRET pour annuler en tout temps. AIDE pour obtenir de l’aide.',
        textStopAddress: ' Sephora : 600, boul. de Maisonneuve Ouest, bureau 2400, Montréal (Québec)  H3A 3J2, Canada 1-877-737-4672.',
        joinNow: 'S’inscrire',
        alreadyHaveAccount: 'Vous avez déjà un compte?',
        signIn: 'Ouvrir une session',
        genericErrorMessage: 'Nous sommes désolés, une erreur s’est produite. Veuillez réessayer plus tard.',
        notYouMessage: 'Ce n’est pas vous?',
        signInHere: 'Ouvrir une session ici',
        confirmButton: 'Continuer',
        invalidEmailError: 'Type d’adresse courriel non valide. Veuillez entrer une adresse courriel valide',
        staySignedInTooltip: 'En sélectionnant cette option, vous n’aurez pas à ouvrir de session aussi souvent sur cet appareil. Pour votre sécurité, nous vous recommandons de le faire uniquement sur vos appareils personnels.',
        sentVerificationLink: 'Nous avons envoyé un lien de vérification à',
        gotIt: 'Compris',
        step1: 'Cliquez sur le lien affiché dans votre courriel pour vérifier votre identité',
        step2: 'Terminer la configuration du compte',
        step3: 'Revenez sur cette page et ouvrez une session pour poursuivre',
        nextStep: 'Prochaines étapes',
        emailMissed: 'Vous ne l’avez pas reçu? Vérifiez vos dossiers de pourriels ou ',
        resend: 'demandez l’envoi d’un nouveau lien.',
        errorResend: 'Un problème est survenu et nous ne pouvons pas renvoyer le courriel. Veuillez réessayer plus tard ou renvoyez le courriel.',
        successResend: 'Courriel renvoyé avec succès.',
        errorModalTitle: 'Erreur',
        successModalTitle: 'Réussi',
        okButton: 'OK',
        resendButton: 'Envoyez le courriel à nouveau',
        congratulation1: 'Félicitations!',
        congratulation2: 'Vous êtes désormais membre Beauty Insider!',
        zipcodeFailed: 'Code postal non valide',
        phoneNumberFailed: 'Numéro de téléphone non valide',
        emailFailed: 'Un compte existe déjà pour l’adresse électronique que vous avez entrée. Veuillez vous connecter ou choisir une autre adresse courriel.',
        phoneNumberRejected: 'Type de téléphone non valide. Veuillez vérifier votre saisie ou utiliser des données valides.',
        byClickingJoinNow: 'En cliquant sur \« S’inscrire et autoriser l’accès »\, vous reconnaissez être résident du Canada ou des États-Unis et (1) avoir lu',
        comma: ', ',
        andChatGPT: 'et de ChatGPT',
        agreeToAutomaticallyReceive: 'acceptez de recevoir automatiquement les offres Beauty Insider par courriel.',
        authorizeChatGPT: 'autorisez ChatGPT à accéder à votre compte Beauty Insider, à vos renseignements personnels et à votre panier d’achat (y compris les mises à jour).',
        reviewOrRemove: 'Vérifiez ou supprimez l’accès en tout temps dans vos paramètres ChatGPT en vous déconnectant de l’appli Sephora.',
        sephora: 'de Sephora',
        joinNowAllowAccess: 'S’inscrire et autoriser l’accès',
        authorizationFailed: 'L’autorisation a échoué. Veuillez essayer de nouveau.',
        emailFormatError: 'please enter an e-mail address in the format username@domain.com.',
        errorResendShort: 'something went wrong, and we could not resend the email.',
        invalidBirthDate: 'please enter your birth date',
        invalidBirthMonth: 'please enter your birth month'

    };

    return resources[label];
}
